/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Md_Mermaid_ErrorInputs */

const en_md_mermaid_error = /** @type {(inputs: Md_Mermaid_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This diagram couldn't be rendered — showing its source instead.`)
};

const id_md_mermaid_error = /** @type {(inputs: Md_Mermaid_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagram ini tidak bisa dirender — ditampilkan sumbernya saja.`)
};

/**
* | output |
* | --- |
* | "This diagram couldn't be rendered — showing its source instead." |
*
* @param {Md_Mermaid_ErrorInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const md_mermaid_error = /** @type {((inputs?: Md_Mermaid_ErrorInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Md_Mermaid_ErrorInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_md_mermaid_error(inputs)
	return en_md_mermaid_error(inputs)
});